import request from '@/utils/request'

/**
 * 认证相关API
 */
export const authApi = {
  // 用户登录 - 使用新的 API 认证接口
  login(loginData) {
    return request({
      url: '/api/auth/login',
      method: 'post',
      data: {
        username: loginData.username,
        password: loginData.password,
        remember: loginData.remember || false,
        captchaKey: loginData.captchaKey,
        captchaCode: loginData.captchaCode
      }
    })
  },
  
  // 获取当前登录用户信息
  getUserInfo() {
    return request({
      url: '/api/auth/userinfo',
      method: 'get'
    })
  },
  
  // 退出登录
  logout() {
    return request({
      url: '/api/auth/logout',
      method: 'post'
    })
  }
}
